import styled from 'styled-components';

export const IconContainer = styled.div<{ disabled?: boolean }>`
  width: fit-content;
  cursor: ${({ disabled }) => disabled && 'not-allowed'};
`;

export const Ul = styled.ul`
  list-style: none;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
`;
export const Li = styled.li`
  padding: 0 16px;
  display: flex;
  align-items: center;
  min-height: 26px;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors[1400]};
  :not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors[700]};
  }
  cursor: pointer;
  transition: filter 0.3s;
  background-color: ${({ theme }) => theme.colors[1300]};

  :hover {
    filter: brightness(95%);
  }

  :active {
    filter: brightness(85%);
  }
`;
